import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/services/apiClient';

export interface BrandInfo {
  name: string;
  displayName: string;
  contactEmail: string;
  apiVersion: string;
  serverTime: string;
}

const FALLBACK: BrandInfo = {
  name: 'MCCWA',
  displayName: 'Muslim Community Center of Winchester Area',
  contactEmail: 'Masjidwinchester@yahoo.com',
  apiVersion: 'v1',
  serverTime: '',
};

export function useBrandInfo(): BrandInfo {
  const { data } = useQuery({
    queryKey: ['brand-info'],
    queryFn: () => apiGet<Partial<BrandInfo>>('/info'),
    staleTime: 1000 * 60 * 60,
    retry: 1,
  });
  return { ...FALLBACK, ...(data ?? {}) };
}
